<div id="page_content">
<div id="page_content_header" class="uk-blur-background" style="margin-top: 0"></div>
<div id="page_content_actions" class="uk-blur-background" uk-sticky>
  <sidebar-mobile-toggle [activeSidebarItemStatic]="'Open Access Publications'" class="uk-hidden@m"></sidebar-mobile-toggle>
</div>
<div id="page_content_inner" class="">
  <div class="uk-section uk-section-small">
  <div class="uk-container">

    <div class="uk-flex uk-flex-middle uk-margin-bottom">
      <img ngSrc="../../survey-tool/assets/images/flags/{{countryCode | lowercase}}-flag-round.png"
           class="flag-image" width="42" height="42" alt="rounded flag image">
      <div class="uk-margin-small-left">
        <h4 class="uk-margin-remove-bottom">{{ countryName }} - Open Access Publications</h4>
      </div>
    </div>

  </div>
</div>

<div class="uk-section uk-section-small uk-padding-remove-top">
  <div class="uk-container">

<!--    <div class="uk-flex uk-flex-between uk-flex-middle">-->
<!--      <h5>Open Access Publications</h5>-->
<!--    </div>-->

    <p class="uk-text-lead">Open Access (OA) represents a transformative approach within the scholarly communication landscape, aiming to make research outputs freely accessible to all, without subscription or price barriers. The graphics below provides a high-level overview of key indicators tracking the progress of OA publishing and policies in selected country.</p>

    <div class="uk-flex uk-flex-between uk-flex-middle uk-margin-medium-top">
      <h5>General Overview of Open Access for 2023</h5>
    </div>

    <div class="uk-grid-small uk-grid-match" data-uk-grid>

      <div class="uk-width-expand uk-animation-fade" *ngIf="hasAnyLeftCardData()">
        <div class="uk-card uk-card-default uk-card-body visualisation-card">
          <div class="uk-child-width-1-2 uk-grid-small uk-flex uk-flex-center" data-uk-grid>

            <!-- Card 1 -->
            <div *ngIf="OAPubsPercentage[1] !== null" class="uk-animation-scale-up">
              <div class="uk-card card-simple uk-card-small uk-card-body">
                <p>OA Publication in {{ countryName }} (OA vs Closed)</p>
                <div class="number big uk-margin-medium-top">
                  <span class="uk-text-bold">{{ OAPubsPercentage[1] }}%</span>
                </div>
                <div *ngIf="OAPubsPercentageDiff !== null" class="uk-flex uk-flex-bottom uk-flex-between uk-width-1-1">
                  <div class="uk-flex uk-flex-middle">
                    <span class="material-symbols-outlined" [ngClass]="OAPubsPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ OAPubsPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                    </span>
                    <span [ngClass]="OAPubsPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ Math.abs(OAPubsPercentageDiff) }}%
                    </span>&nbsp; from last year
                  </div>
                  <div>
                    <img [ngSrc]="'../assets/images/explore/' + (OAPubsPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                         alt="trend image" height="50" width="99">
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 2 -->
            <div *ngIf="rfoPubsPercentage[1] !== null" class="uk-animation-scale-up">
              <div class="uk-card card-simple uk-card-small uk-card-body">
                <p>RFOs with Policy on OA Publication</p>
                <div class="number big uk-margin-medium-top">
                  <span class="uk-text-bold">{{ rfoPubsPercentage[1] }}%</span>
                </div>
                <div *ngIf="rfoPubsPercentageDiff !== null" class="uk-flex uk-flex-bottom uk-flex-between uk-width-1-1">
                  <div class="uk-flex uk-flex-middle">
                    <span class="material-symbols-outlined" [ngClass]="rfoPubsPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ rfoPubsPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                    </span>
                    <span [ngClass]="rfoPubsPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ Math.abs(rfoPubsPercentageDiff) }}%
                    </span>&nbsp; from last year
                  </div>
                  <div>
                    <img [ngSrc]="'../assets/images/explore/' + (rfoPubsPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                         alt="trend image" height="50" width="99">
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 3 -->
            <div *ngIf="rpoPubsPercentage[1] !== null" class="uk-animation-scale-up">
              <div class="uk-card card-simple uk-card-small uk-card-body">
                <p>RPOs with Policy on OA Publication</p>
                <div class="number big uk-margin-medium-top">
                  <span class="uk-text-bold">{{ rpoPubsPercentage[1] }}%</span>
                </div>
                <div *ngIf="rpoPubsPercentageDiff !== null" class="uk-flex uk-flex-bottom uk-flex-between uk-width-1-1">
                  <div class="uk-flex uk-flex-middle">
                    <span class="material-symbols-outlined" [ngClass]="rpoPubsPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ rpoPubsPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                    </span>
                    <span [ngClass]="rpoPubsPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ Math.abs(rpoPubsPercentageDiff) }}%
                    </span>&nbsp; from last year
                  </div>
                  <div>
                    <img [ngSrc]="'../assets/images/explore/' + (rpoPubsPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                         alt="trend image" height="50" width="99">
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div *ngIf="financialInvestment[1] !== null" class="uk-animation-scale-up">
              <div class="uk-card card-simple uk-card-small uk-card-body">
                <p>Financial investments in OA publications</p>
                <div class="number big uk-margin-medium-top">
                  <span class="uk-text-bold">{{ financialInvestment[1]  + ' mil Euro' }}</span>
                </div>
                <div *ngIf="financialInvestmentPercentageDiff !== null" class="uk-flex uk-flex-bottom uk-flex-between uk-width-1-1">
                  <div class="uk-flex uk-flex-middle">
                    <span class="material-symbols-outlined" [ngClass]="financialInvestmentPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ financialInvestmentPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                    </span>
                    <span [ngClass]="financialInvestmentPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                      {{ Math.abs(financialInvestmentPercentageDiff) }}%
                    </span>&nbsp; from last year
                  </div>
                  <div>
                    <img [ngSrc]="'../assets/images/explore/' + (financialInvestmentPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                         alt="trend image" height="50" width="99">
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="uk-margin-top">
            <span class="uk-text-bold">Data source:</span>&nbsp; Survey on National Contributions to EOSC and Open Science; OpenAIRE Graph.
          </div>
        </div>

      </div>

      <!-- Right Card (2/5) -->
      <div class="uk-width-2-5 uk-animation-fade">
        <div class="uk-card uk-card-default uk-card-body visualisation-card">
          <div class="uk-margin-top">
            <h6 class="uk-flex uk-flex-between uk-margin-remove">
              National Policy on Open Access
              <span
               class="material-symbols-outlined"
                [ngClass]="{
                  'up-arrow-color': nationalPolicyResponse === 'Yes',
                  'down-arrow-color': nationalPolicyResponse === 'No',
                  'unanswered-color': nationalPolicyResponse === null || nationalPolicyResponse === undefined
                }">
                {{
                  nationalPolicyResponse === 'Yes' ? 'check' :
                  nationalPolicyResponse === 'No' ? 'close' :
                  'question_mark'
                }}
              </span>
            </h6>
            <p *ngIf="policyMandatory === 'Yes'" class="uk-text-primary uk-text-bolder uk-margin-remove-top">Mandatory policy</p>
            <read-more-text *ngIf="nationalPolicyClarification !== null" [maxHeight]="68" [text]="nationalPolicyClarification"></read-more-text>
          </div>
          <div class="uk-margin-top">
            <h6 class="uk-flex uk-flex-between">
              Financial Strategy on Open Access
              <span
               class="material-symbols-outlined"
                [ngClass]="{
                  'up-arrow-color': financialStrategyResponse === 'Yes',
                  'down-arrow-color': financialStrategyResponse === 'No',
                  'unanswered-color': financialStrategyResponse === null || financialStrategyResponse === undefined
                }">
                {{
                  financialStrategyResponse === 'Yes' ? 'check' :
                  financialStrategyResponse === 'No' ? 'close' :
                  'question_mark'
                }}
              </span>
            </h6>
            <read-more-text *ngIf="financialStrategyResponse" [maxHeight]="68" [text]="financialStrategyClarification"></read-more-text>
          </div>
          <div class="uk-margin-top">
            <h6 class="uk-flex uk-flex-between">
              Monitoring on Open Access
              <span
               class="material-symbols-outlined"
                [ngClass]="{
                  'up-arrow-color': monitoringResponse === 'Yes',
                  'down-arrow-color': monitoringResponse === 'No',
                  'unanswered-color': monitoringResponse === null || monitoringResponse === undefined
                }">
                {{
                  monitoringResponse === 'Yes' ? 'check' :
                  monitoringResponse === 'No' ? 'close' :
                  'question_mark'
                }}
              </span>
            </h6>
            <read-more-text *ngIf="monitoringResponse" [maxHeight]="68" [text]="monitoringClarification"></read-more-text>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

<div *ngIf="hasSurveyPublicationData()"  class="uk-section uk-section-small uk-margin-top">
  <div class="uk-container">

    <div class=" uk-animation-fade">
      <div class="uk-card uk-card-body uk-card-default uk-width-1-1 noads visualisation-card">
        <read-more [maxHeight]="300">
          <h6 class="uk-margin-bottom">Open Access Landscape in {{ countryName }}</h6>
          <div class="uk-text-meta">This information has been compiled by the National Open Access Desks</div>
          <div class="uk-margin-medium-top" id="open_access_publishing">
            <div class="uk-text-secondary">Open Access Publishing</div>
            <ng-container *ngIf="countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question7']; else open_access">
              <div [innerHTML]="countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question7']" class="uk-margin-medium-top"></div>
            </ng-container>
            <ng-template #open_access><p>N/A</p></ng-template>
          </div>
        </read-more>
      </div>
    </div>

  </div>
</div>


<div class="uk-section uk-section-small uk-margin-top">
  <div class="uk-container">

    <div class="uk-card uk-card-default visualisation-card openaire-graph uk-card-body uk-animation-fade">
      <div class="uk-grid">
        <div class="uk-width-1-1">
          <app-stacked-column [categories]="stackedColumnCategories" [legend]="legend" [series]="stackedColumnSeries"
                              [yAxis]="yAxisTitle" [pointFormat]="tooltipPointFormat" [stackLabels]="false"
                              [dataLabels]="false" [height]="700" [title]="'Trend of Access to Publications in ' + countryName"
                              [caption]="'<p class=\'uk-text-justify\'>The graph provides a view of the publications evolution and its access type from 2015 to 2024 in the selected country. Each bar in the graph represents the total number of publications for a given year, segmented by access type categories (categories based on <a href=&quot;https://vocabularies.coar-repositories.org/access_rights/access_rights_for_dspace_en.xml&quot; target=\'_blank\'>https://vocabularies.coar-repositories.org/access_rights/access_rights_for_dspace_en.xml</a>).</p>'
                              + '<p><strong>Data Source:</strong> OpenAIRE Graph (updated on ' + lastUpdateDate + ').</p>'">
          </app-stacked-column>
        </div>
      </div>
    </div>

  </div>
</div>


<div class="uk-section uk-section-small uk-margin-top">
  <div class="uk-container">
    <h5></h5>
    <div class="uk-container">

      <div class="uk-card uk-card-default visualisation-card openaire-graph uk-card-body">
        <app-stacked-column [categories]="stackedColumn2Categories" [series]="stackedColumn2Series"
                            [title]="'Distribution of Open Access Types by Different Scholarly Publication Outputs in ' + countryName"
                            [yAxis]="yAxisTitle2" [pointFormat]="tooltipPointFormat" [plotFormat]="dataLabels_format"
                            [stackLabels]="false" [stacking]="stacking" [height]="550"
                            [caption]="'<p class=\'uk-text-justify\'>The graph displays the distribution of OA types across different scholarly publication categories, revealing distinct preferences and practices in the dissemination of research outputs. This visualization provides insight into the diverse adoption rates and strategies for OA across various academic outputs. Understanding these differences is crucial for identifying specific barriers and opportunities within each publication category, thereby guiding stakeholders in tailoring interventions that encourage broader adoption of OA. This targeted approach can significantly contribute to enhancing the accessibility of knowledge, fostering a more open and collaborative scientific community.</p>'
                            + '<p><strong>Data Source: </strong> OpenAIRE Graph data for 2022 (updated on ' + lastUpdateDate + ')</p>'">
        </app-stacked-column>
      </div>
    </div>

  </div>
</div>

<div class="uk-section uk-section-small uk-margin-top">
  <div class="uk-container">

    <div class="uk-card uk-card-default visualisation-card openaire-graph uk-card-body">
      <app-multi-chart [series]="bar" [categories]="barCategories" stacking="normal"
                       [titles]="barChartTitles" [height]="500"
                       [duplicateXAxis]="true" [yAxisLabels]="true" [dataLabelFormat]="'{(abs value)}'"
                       [tooltip]="'<b>{series.name},</b> {point.category}<br/>{(abs point.y)}'"
                       [caption]="'<p class=\'uk-text-justify\'>This garaph illustrates the distribution of OA types within various scientific disciplines including Medical and Health Sciences, Engineering and Technology, Agricultural Sciences, Natural Science, Social Sciences, and Humanities.</p>'
                       + '<strong>Data Source: </strong> OpenAIRE Graph data for 2022 (updated on '+ lastUpdateDate +')'">
      </app-multi-chart>
    </div>

  </div>
</div>
</div>
<div id="page_content_footer"></div>
</div>
